const STORAGE_KEY = "requisition-pdf-debug-log";
const MAX_ENTRIES = 80;

const isDebugEnabled = () => process.env.REACT_APP_DEBUG_REQUISITION_PDF === "true";

const pushToStorage = (entry) => {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		const logs = Array.isArray(JSON.parse(raw || "[]")) ? JSON.parse(raw || "[]") : [];
		logs.push(entry);
		if (logs.length > MAX_ENTRIES) {
			logs.splice(0, logs.length - MAX_ENTRIES);
		}
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
	} catch {
		// ignore storage errors
	}
};

/** Production-safe debug logger for Referral PDF / Download Order flow. */
export const logRequisitionPdfDebug = (label, data = {}) => {
	if (!isDebugEnabled()) return;

	const entry = {
		t: new Date().toISOString(),
		label,
		data,
	};

	pushToStorage(entry);

	const consoleRef = typeof window !== "undefined" ? window["console"] : null;
	if (consoleRef && typeof consoleRef["log"] === "function") {
		consoleRef["log"]("[RequisitionPDF]", label, data);
	}
};

export const getRequisitionPdfDebugLogs = () => {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		return Array.isArray(JSON.parse(raw || "[]")) ? JSON.parse(raw || "[]") : [];
	} catch {
		return [];
	}
};

export const clearRequisitionPdfDebugLogs = () => {
	try {
		sessionStorage.removeItem(STORAGE_KEY);
	} catch {
		// ignore
	}
};

if (isDebugEnabled() && typeof window !== "undefined") {
	window.__requisitionPdfDebug = {
		getLogs: getRequisitionPdfDebugLogs,
		clear: clearRequisitionPdfDebugLogs,
		print: () => {
			const logs = getRequisitionPdfDebugLogs();
			const c = window["console"];
			if (c && typeof c["table"] === "function") {
				c["table"](logs);
			} else if (c && typeof c["log"] === "function") {
				c["log"](logs);
			}
			return logs;
		},
	};
}
